/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AgreementStatusEmailConfigDto } from '../../models/agreement-status-email-config-dto';

export interface AgreementsControllerUpsertTicketStatusEmailConfig$Params {
  id: number;
  ticket_status_id: number;
      body: AgreementStatusEmailConfigDto
}

export function agreementsControllerUpsertTicketStatusEmailConfig(http: HttpClient, rootUrl: string, params: AgreementsControllerUpsertTicketStatusEmailConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, agreementsControllerUpsertTicketStatusEmailConfig.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('ticket_status_id', params.ticket_status_id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

agreementsControllerUpsertTicketStatusEmailConfig.PATH = '/agreements/{id}/ticket-status-email-configs/{ticket_status_id}';
